<script lang="ts">
    export let suggestion;
    export let highlighted: Boolean;
</script>

<button
        id={suggestion.id}
        class="list-group-item list-group-item-action"
        class:active={highlighted}
        value={suggestion.id}
>
    <b> Name: </b> {suggestion.name} <br />
    <b> Id: </b> {suggestion.id}
</button>

<style>
    .active {
        --bs-list-group-active-bg: #007EC6;
    }
</style>